export default "__VITE_ASSET__eOna$JRR__"